/**
 * Copyright © 2026 Delicious AI, LLC
 */

import { gql } from '@apollo/client'
import { SABRE_PRODUCT_MODEL_EXCLUSION_FRAGMENT } from '../fragments/ProductModelExclusionFragment'

export const SABRE_SET_PRODUCT_EXCLUDED_FROM_MODELS = gql`
  mutation SetProductExcludedFromModels(
    $input: SetProductExcludedFromModelsInput!
  ) {
    setProductExcludedFromModels(input: $input) {
      product {
        ...ProductModelExclusion
      }
    }
  }
  ${SABRE_PRODUCT_MODEL_EXCLUSION_FRAGMENT}
`
